import { render, staticRenderFns } from "./MainPacking.vue?vue&type=template&id=2edd3c0a&"
import script from "./MainPacking.vue?vue&type=script&lang=js&"
export * from "./MainPacking.vue?vue&type=script&lang=js&"
import style0 from "./MainPacking.vue?vue&type=style&index=0&id=2edd3c0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports